var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',{attrs:{"src":_vm.src,"fit":_vm.fit,"preview-src-list":_vm.previewSrcList},on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }